import createNavigation from "components/masthead/helpers/create_navigation";
import "./component.scss";
import { initSameDayBadges } from "components/jiffy/products/product-composition-estimates";

const { initDesktopNavigation, initMobileNavigation } = createNavigation({
  containerSelector: ".js-masthead-transfers-navigation",
  navigationLinkSelector: ".js-masthead-transfers-navigation-link",
  navigationContentSelector: ".js-masthead-transfers-navigation-content",
  activeLinkClassName: "masthead-transfers-navigation__section--active",
  slideSelector: ".js-masthead-transfers-slide",
  slideLinkSelector: ".js-masthead-transfers-slide-link",
  expandedSlideClassName: "masthead-transfers-navigation__slide--expanded",
  backSelector: '.js-mobile-submenu-trigger[data-category="Transfers"]',
  mouseleaveCategory: "Transfers",
  mobileBackMode: "reset-all",
  onDesktopInit: initSameDayBadges
});

export { initDesktopNavigation, initMobileNavigation };
